<template>
  <svg
    :width="width"
    :height="height"
    viewBox="-4 -2 24 24"
    class="icon-lock"
    :class="[`icon-lock--color-${color}`]"
  >
    <path
      :d="
        unlock
          ? 'M15.077.019a4.658 4.658 0 0 0-4.083 4.714V7H2a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1.006V4.68a2.624 2.624 0 0 1 2.271-2.67 2.5 2.5 0 0 1 2.729 2.49V8a1 1 0 0 0 2 0V4.5A4.505 4.505 0 0 0 15.077.019ZM9 15.167a1 1 0 1 1-2 0v-3a1 1 0 1 1 2 0v3'
          : 'M14 7h-1.5V4.5a4.5 4.5 0 1 0-9 0V7H2a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Zm-5 8a1 1 0 1 1-2 0v-3a1 1 0 1 1 2 0v3Zm1.5-8h-5V4.5a2.5 2.5 0 1 1 5 0V7Z'
      "
    />
  </svg>
</template>
<script>
  export default {
    name: 'IconLock',
    props: {
      unlock: Boolean,
      color: {
        type: String,
        default: 'white',
        validator: (value) =>
          ['white', 'black', 'grey', 'blue'].includes(value),
      },
      width: {
        type: [Number, String],
        default: 24,
      },
      height: {
        type: [Number, String],
        default: 24,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-lock {
    fill: currentColor;

    &--color-white {
      fill: #ffffff;
    }
    &--color-black {
      fill: #000000;
    }
    &--color-grey {
      fill: #a7a9ab;
    }
    &--color-blue {
      fill: #17355c;
    }
    path d {
      transition: all 0.3s ease;
    }
  }
</style>
